<template>
	<el-dialog title="选择字段" :visible.sync="addFieldShow" width="40%" @close="close" center>
		<el-row>
			<el-col :span="24">
				<el-select v-model="selectedId" placeholder="请选择字段名称">
					<el-option v-for="item in customData" :key="item.dicId" :label="item.dicValue"
						:value="item.dicId" />
				</el-select>
			</el-col>
		</el-row>
		<el-row style="margin-top: 120px;">
			<el-col :span="4">
				<el-button type="success" @click="add">确认</el-button>
			</el-col>
			<el-col :span="4">
				<el-button type="primary" @click="close">取消</el-button>
			</el-col>
		</el-row>

	</el-dialog>
</template>

<script>
	export default {
		props: {
			addFieldShow: {
				type: Boolean,
				default: false
			},
			customData: {
				type: Array,
				default: null
			}
		},
		data() {
			return {
				selectedId: '',
				selectedData: null,
				//模拟数据
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				}
			}
		},
		methods: {
			add() {
				this.addFieldShow = false;
				this.$emit('addFieldClose', false)
				const newData = this.customData;
				for (let i = 0; i < newData.length; i++) {
					if (this.selectedId == newData[i].dicId) {
						this.selectedData = newData[i]
					}
				}
				this.$emit('sendData', this.selectedData)

			},
			close() {
				this.addFieldShow = false;
				this.$emit('addFieldClose', false)
			}
		}
	}
</script>

<style scoped>

</style>
